exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3mirn5s7fX1jq_ePUk1C33{border:0}._3mirn5s7fX1jq_ePUk1C33 a.ZwyBWgBI1Y3ItM1fnnbT-{color:#fff}.lW97s9hbSyo1b74EgtPM0{background-color:#6982ff;border:1px solid #6982ff}.lW97s9hbSyo1b74EgtPM0 h2{color:#f5f5f5}.lW97s9hbSyo1b74EgtPM0 ._16o-B39d3vMHaJsqcVGYE5{margin-top:20px;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"Modal": "_3mirn5s7fX1jq_ePUk1C33",
	"closeButton": "ZwyBWgBI1Y3ItM1fnnbT-",
	"header": "lW97s9hbSyo1b74EgtPM0",
	"inner": "_16o-B39d3vMHaJsqcVGYE5"
};